import React from "react";
import { createStyles } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import { Theme } from "@material-ui/core/styles/createMuiTheme";
import Grid from "@material-ui/core/Grid";
import Table from "@material-ui/core/Table";
import Typography from "@material-ui/core/Typography";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import { QuestionBenchmarks } from "../../types/Benchmarks";
import _ from "lodash";
import { CONTENT_SPECIAL_PURPOSES } from "../../../../constants/comman";
import AddFeedbackPopup from "../ContentCreate/AddFeedbackPopup";

const styles = (theme: Theme) =>
  createStyles({
    titleDesc: {
      marginTop: theme.spacing.unit * 2,
      "& p": {
        margin: 0,
      },
      "& p > img, img": {
        maxWidth: "100%",
      },
    },
    fontSM: {
      fontWeight: 600,
      fontSize: "1rem",
      lineHeight: "22px",
      color: "#333333",
    },
    table:{
      border: '1px solid #F1F1F1',
      marginTop: '5px',
      "& th":{
        fontSize: 16,
        fontWeight: 'bold',
        color: '#333',
      },
      "& td":{
        fontSize: 16,
        fontWeight: 500,
        color: '#333',
      },
		},
		tableHead :{
			backgroundColor: '#f1f1f1',
		},
    feedbackHeadingContainer: {
      display: 'inline',
      position: 'relative',
    },
  });

interface Props {
  data: QuestionBenchmarks;
  classes: any;
  questionSpecialPurposes: any;
  showValidationFeedback?: boolean;
  feedbackData?: any;
  onSectionClick?: Function;
  allowFeedbacks?: boolean;
  handleAddFeedback?: Function; 
  handleCloseFeedback?: Function;
}

function SelectedQuestionBenchmarks(props: Props) {
  const { classes, data, questionSpecialPurposes, showValidationFeedback = false, feedbackData, onSectionClick, allowFeedbacks, handleAddFeedback, handleCloseFeedback } = props;
  if (!data || !data.hasBenchmarks) {
    return null;
  }
  const isFtre = (questionSpecialPurposes || []).includes(CONTENT_SPECIAL_PURPOSES.FTRE);
  const handleSectionClick = () => {
    onSectionClick && onSectionClick();
  };
  return (
    <div className={classes.titleDesc} onClick={handleSectionClick}>
      <Typography variant="body2" className={[classes.fontSM, classes.feedbackHeadingContainer].join(" ")}>
        Benchmarking:{" "}
        { showValidationFeedback && <AddFeedbackPopup  handleAdd={handleAddFeedback} handleCancel={handleCloseFeedback} allowFeedbacks={allowFeedbacks} feedbackData={feedbackData} /> }
      </Typography>
      <Grid container spacing={24}>
        <Grid item xs={9}>
          <Table className={classes.table}>
            <TableHead className={classes.tableHead}>
              <TableRow>
                <TableCell>Target Exam</TableCell>
                <TableCell>{ isFtre ? 'RPI/Potential' : 'Goal Level'}</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data.benchmarks.map(
                ({
                  goalLevel: { name: goalLevelName },
                  course,
                }, i) => {
                  const courseName = _.get(course, 'name', '');
                  return  (
                  <TableRow key={i}>
                    <TableCell>{courseName}</TableCell>
                    <TableCell>{goalLevelName}</TableCell>
                  </TableRow>
                )}
              )}
            </TableBody>
          </Table>
        </Grid>
      </Grid>
    </div>
  );
}

export default withStyles(styles)(SelectedQuestionBenchmarks);
